import React from 'react';

export default function EditTimestamp({ title, subtitle }) {
  return null;
}
